export class AdminUpdatePlanPeriod {
  price: number

  isActive: boolean

  constructor(data: Partial<AdminUpdatePlanPeriod> = {}) {
    this.price = data.price ?? 0

    this.isActive = data.isActive ?? true
  }
}
